import React, { useState } from 'react'
import { Button, Box, Divider, Modal, styled, Typography, Link } from '@material-ui/core'
import { placeImage } from '../../utils'
import CustomButton from '../Button/CustomButton'

const PaddingBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5, 3),
  '& a': {
    marginLeft: '10px'
  }
}))

const SubtitleTypography = styled(Typography)(() => ({
  fontSize: '0.825rem',
  opacity: 0.6,
  letterSpacing: '.5px'
}))
const TitleTypography = styled(Typography)(() => ({
  fontSize: '0.875rem',
  fontWeight: 'bold',
  letterSpacing: '.5px'
}))

const MainContent = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  '& ol': {
    listStyle: 'decimal',
    marginLeft: '20px'
  },
  '& li': {
    marginBottom: 'unset'
  }
}))
const StoreBtnsBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  '& a': {
    display: 'inline-flex',
    justifyContent: 'center'
  },
  '& a:first-child': {
    marginRight: theme.spacing(1)
  }
}))
const SimpleBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 510,
  minWidth: 300,
  backgroundColor: theme.colors.white,
  borderRadius: 4
}))

const CloseIcon = styled('button')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  padding: 12,
  display: 'inline-flex',
  border: 'none',
  borderRadius: '50%',
  cursor: 'pointer',
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: theme.colors.grey1,
    '& svg': {
      opacity: 0.7
    }
  },
  '& svg': {
    opacity: 0.5,
    width: 20,
    height: 20
  }
}))

function SimpleModal(props) {
  const [open, setOpen] = useState(false)

  const handleOpen = (e) => {
    e.preventDefault()
    if (props.isInsideText) {
      const el = e.target.closest('A')
      if (el && e.currentTarget.contains(el) && el.href.indexOf('#') > 0) {
        setOpen(true)
      }
    } else {
      setOpen(true)
    }
  }

  const handleClose = () => {
    setOpen(false)
  }
  return (
    <>
      {React.cloneElement(props.children, { onClick: (e) => handleOpen(e) })}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal"
        aria-describedby="simple-modal"
        data-ads-event={props.adsEvent}
      >
        <SimpleBox>
          <PaddingBox>
            <TitleTypography variant="h3">{props.title}</TitleTypography>
            <SubtitleTypography variant="h4">{props.subtitle}</SubtitleTypography>
          </PaddingBox>
          <CloseIcon onClick={() => handleClose()}>
            <svg id="close" viewBox="0 0 36 36" width="100%" height="100%">
              <path
                fillRule="evenodd"
                d="M26.098 23.785a1.637 1.637 0 1 1-2.313 2.315L18 20.314 12.215 26.1a1.637 1.637 0 0 1-2.313-2.315L15.686 18l-5.784-5.785A1.637 1.637 0 1 1 12.215 9.9L18 15.686l5.785-5.784c.64-.64 1.675-.64 2.313 0 .64.636.64 1.674 0 2.313L20.314 18l5.784 5.785zM18 0C8.06 0 0 8.06 0 18s8.06 18 18 18 18-8.06 18-18S27.94 0 18 0z"
              ></path>
            </svg>
          </CloseIcon>
          <Divider />
          {props.content && (
            <MainContent variant="body1" dangerouslySetInnerHTML={{ __html: props.content }} />
          )}
          {props.store && (
            <StoreBtnsBox display="flex" flexDirection="row" alignItems="center">
              {props.appStoreImage && (
                <Link data-app-store="Apple" href={props.appStoreUrl} target="_blank">
                  {props.appStoreImage.url ? (
                    placeImage(props.appStoreImage)
                  ) : (
                    <img src={props.appStoreImage} alt="app store" style={{ height: 42 }} />
                  )}
                </Link>
              )}
              {props.playStoreImage && (
                <Link data-app-store="Google" href={props.playStoreUrl} target="_blank">
                  {props.playStoreImage.url ? (
                    placeImage(props.playStoreImage)
                  ) : (
                    <img src={props.playStoreImage} alt="app store" style={{ height: 42 }} />
                  )}
                </Link>
              )}
            </StoreBtnsBox>
          )}
          {props.ctas && (
            <>
              <Divider />
              <PaddingBox display="flex" justifyContent="flex-end">
                {props.cancel && (
                  <CustomButton variant="outlined" color="whiteoutlined" onClick={handleClose}>
                    {props.cancel}
                  </CustomButton>
                )}
                {props.primary && (
                  <Button
                    variant="contained"
                    color="primary"
                    href={props.primary.href}
                    target={props.primary.target}
                  >
                    {props.primary.text}
                  </Button>
                )}
              </PaddingBox>
            </>
          )}
        </SimpleBox>
      </Modal>
    </>
  )
}

export default SimpleModal
